import { GENERAL_TEXT } from '@/texts/catalog/general';

export const ALL_OPTION_VALUE = '__all__';

export const createAllOption = () => ({ value: ALL_OPTION_VALUE, label: GENERAL_TEXT.selection.all });

export const withAllOption = (items) => [createAllOption(), ...(Array.isArray(items) ? items : [])];

export const ensureDefaultSelection = (selected, defaultOption) => {
  const current = Array.isArray(selected) ? selected : [];
  if (current.length > 0) {
    return current;
  }

  return defaultOption ? [defaultOption] : [];
};

export const applySelectOption = (selected, option, defaultOption) => {
  if (option?.value === ALL_OPTION_VALUE) {
    return defaultOption ? [defaultOption] : [];
  }

  const current = Array.isArray(selected) ? selected : [];
  return current.filter((item) => item?.value !== ALL_OPTION_VALUE);
};

export const applyRemoveOption = (selected, defaultOption) => {
  const current = Array.isArray(selected) ? selected : [];
  if (current.length > 0) {
    return current;
  }

  return defaultOption ? [defaultOption] : [];
};

export const buildSelectionLabel = (values) => {
  const selected = Array.isArray(values) ? values : [];

  if (selected.length === 0) {
    return GENERAL_TEXT.selection.all;
  }

  if (selected.some((option) => option?.value === ALL_OPTION_VALUE)) {
    return GENERAL_TEXT.selection.all;
  }

  if (selected.length === 1) {
    return selected[0]?.label || GENERAL_TEXT.selection.all;
  }

  return `${selected.length} ${GENERAL_TEXT.selection.selectedSuffix}`;
};

export const buildSelectedValues = (selected) => {
  const current = Array.isArray(selected) ? selected : [];

  if (current.some((option) => option?.value === ALL_OPTION_VALUE)) {
    return [];
  }

  return current
    .map((option) => option?.value)
    .filter((value) => value !== undefined && value !== null && value !== '');
};